import HrDashboardPage from "./HrDashboardPage";

export default function HrAnalyticsPage() {
  return <HrDashboardPage title="تحليلات الموارد البشرية" />;
}
